<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
import TypographyWithPrefix from '@/components/Typography/TypographyWithPrefix.vue'
import type { DeviceModel } from '@/types/models/DeviceModel'
import { DATETIME_FORMAT } from '@/utils/dateUtils'
import moment from 'moment'
import store from '../../../../../store'

type Props = {
    data?: Partial<DeviceModel>
}
defineProps<Props>()
</script>

<template>
    <StackLayout
        v-if="
            data &&
            data?.rental?.renter?.organization_id === store.state.authentication.me.organization_id
        "
        direction="column">
        <TypographyWithPrefix
            v-if="data.rental?.start_at"
            :prefix="$t('device.rental.startAt')"
            :label="moment(data.rental.start_at).format(DATETIME_FORMAT)"
            boldLabel />
        <TypographyWithPrefix
            v-if="data.rental?.end_at"
            :prefix="$t('device.rental.endAt')"
            :label="moment(data.rental.end_at).format(DATETIME_FORMAT)"
            boldLabel />
    </StackLayout>
</template>
